import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps
} from '@fortawesome/react-fontawesome';

export const faXTwitter: IconDefinition = {
  prefix: 'fab',
  iconName: 'x-twitter' as any,
  icon: [
    512,
    512,
    [],
    'f099',
    'M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 240.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z'
  ]
};

type XTwitterIconProps = Omit<FontAwesomeIconProps, 'icon'>;

export const XTwitterIcon = (props: XTwitterIconProps): JSX.Element => (
  <FontAwesomeIcon icon={faXTwitter} {...props} />
);
